import { V3Record } from "data/helpers/V3Record.js";

export const Relationship = V3Record("relationship", {
  id: null,
  befrienderId: null,
  befriendeeId: null,
  befrienderRelationshipTypeId: null,
  befriendeeRelationshipTypeId: null,
  createdAt: null,
});
